const DeveloperDashboard = () => {
  return <div>DeveloperDashboard</div>;
};

export default DeveloperDashboard;
